import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { createVuetify } from 'vuetify'

export const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'pocroLight',
    themes: {
      pocroLight: {
        dark: false,
        colors: {
          primary: '#1b365d',
          secondary: '#4d6f91',
          background: '#f4f6f8',
          surface: '#ffffff',
          navigation: '#d9dce0',
          navigationActive: '#3a424e',
          border: '#d7dde5',
          muted: '#6E6D76',
        },
      },
    },
  },
})
